module.exports = __webpack_public_path__ + "b7251ea47006b9e9f3a69f15d65b8d31.png";